// [S-637 slice 2] Typed session-expiry error.
//
// Before this, `getFreshJwt` re-threw a RAW `Error` when a refresh failed past
// token expiry (Mode 2). Raw errors aren't `ApiError`, so `getApiErrorMessage`
// returned null and the user saw a generic broken state. This gives the expiry
// a single recognizable type the UI reacts to consistently — the API layer
// throws it, `getApiErrorMessage` maps it to a coherent message, and the global
// re-auth modal is what actually drives recovery.
export class SessionExpiredError extends Error {
  override readonly name = "SessionExpiredError";
  constructor(options?: { cause?: unknown }) {
    super("Your session expired", options);
  }
}

export function isSessionExpiredError(error: unknown): error is SessionExpiredError {
  return error instanceof SessionExpiredError;
}
